// extracted by mini-css-extract-plugin
export default {"block":"Loader_block__yjd+o","loader":"Loader_loader__3+ohf","spinner":"Loader_spinner__SGciW"};